export default __webpack_public_path__ + "31496d4e70eb439eeafdddd74eeb54df.png";